<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length > 0 && total > 0">
        <v-data-table
          dense
          height="300"
          class="v-data-table-no-border"
          :headers="headers"
          :items="data"
          item-key="id"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="{
            'items-per-page-options': [1000],
            'items-per-page-text': 'Mostrar',
          }"
        >
          <template v-slot:[`item.date`]="{ item }">
            <div class="d-flex align-items-center">
              <span v-if="item.view_date" class="text-twelve">
                <span class="weight-600">
                  {{ moment(item.view_date).format("DD") }}
                </span>
                <span class="text-capitalize">{{
                  moment(item.view_date).format("MMM")
                }}</span>
              </span>
            </div>
          </template>
          <template v-slot:[`item.categories`]="{ item }">
            <div v-if="item.type == 'TRANSFERENCIA'">
              <small
                class="text-eleven noBorderRadius v-primary pl-2 pr-2 pt-1 pb-1 c-white"
              >
                TRANSFERÊNCIA
              </small>
            </div>
            <div
              v-if="
                item.type == 'CONTAS_A_PAGAR' || item.type == 'CONTAS_A_RECEBER'
              "
            >
              <span v-if="item.categories.length == 1">
                {{ item.finance_configuration_category_name }}
              </span>

              <div
                v-if="item.categories.length > 1"
                class="d-flex align-items-center"
              >
                <span
                  v-for="(category, key) in item.categories"
                  :key="key"
                  :style="`background-color: ${
                    category.color ? category.color : '#999'
                  }`"
                  :class="[
                    'mr-1 pl-1 pr-1 m-0 worksansr text-fifteen',
                    String(category.color).toUpperCase() == '#FFFFFF'
                      ? ''
                      : 'c-white',
                  ]"
                >
                  {{ String(category.name).substring(0, 1) }}
                </span>
              </div>
            </div>
          </template>
          <template v-slot:[`item.description`]="{ item }">
            <div
              class="row m-0"
              v-if="
                item.type == 'previous_balance' ||
                item.type == 'opening_balance'
              "
            >
              <div
                :class="[
                  'd-flex align-items-center p-0 text-thirteen',
                  item.type == 'previous_balance' && 'col-md-12',
                  item.type == 'opening_balance' && 'col-md-12',
                ]"
              >
                {{ item.description }}
              </div>
              <div
                :class="[
                  'p-0',
                  item.type == 'previous_balance' && 'col-md-12 pt-0 pb-0',
                  item.type == 'opening_balance' && 'col-md-12',
                ]"
              >
                <p
                  class="m-0 worksansr text-thirteen"
                  v-for="(account, account_key) in item.accounts"
                  :key="`${account.account_nickname}-${account_key}`"
                >
                  [{{ account.account_nickname }}]
                  <span class="c-success" v-if="account.account_status == 1">
                    {{ formatMoney(String(account.balance_date)) }}
                  </span>
                  <span class="c-danger" v-if="account.account_status == 0">
                    -{{ formatMoney(String(account.balance_date)) }}
                  </span>
                </p>
              </div>
            </div>
            <span
              v-if="item.is_purchase == 1"
              class="worksansr p-1 m-0 v-warning noBorderRadius text-ten"
            >
              GERADO PELA COMPRA
            </span>
            <v-tooltip bottom max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <div
                    v-if="
                      item.type != 'previous_balance' &&
                      item.type != 'opening_balance'
                    "
                  >
                    <p class="m-0 limit-text worksansr text-twelve">
                      {{
                        item.finance_launch_bills_to_pay_installments_items
                          .length > 1
                          ? `(${item.finance_launch_bills_to_pay_installments_items.length})`
                          : ""
                      }}
                      {{ item.description }}
                    </p>
                  </div>
                </div>
              </template>
              <span v-if="item.id">
                <div class="row m-0">
                  <div
                    class="col-md-12 pt-0 pb-0 d-flex flex-column text-twelve"
                    v-if="
                      item.type == 'CONTAS_A_PAGAR' ||
                      item.type == 'CONTAS_A_RECEBER'
                    "
                  >
                    <b>Conta</b>
                    <small>
                      {{ item.finance_configuration_account_name }}
                    </small>
                  </div>
                  <div
                    class="col-md-4 pt-0 pb-0 d-flex flex-column text-twelve"
                    v-if="
                      item.type == 'CONTAS_A_PAGAR' ||
                      item.type == 'CONTAS_A_RECEBER'
                    "
                  >
                    <b>Competência</b>
                    <small>
                      {{ moment(item.competence).format("DD/MM/YYYY") }}
                    </small>
                  </div>
                  <div
                    class="col-md-4 pt-0 pb-0 d-flex flex-column text-twelve"
                    v-if="
                      item.type == 'CONTAS_A_PAGAR' ||
                      item.type == 'CONTAS_A_RECEBER'
                    "
                  >
                    <b>Vencimento</b>
                    <small>{{
                      moment(item.due_date).format("DD/MM/YYYY")
                    }}</small>
                  </div>
                  <div
                    class="col-md-8 pt-0 pb-0 d-flex flex-column text-twelve"
                    v-if="item.type == 'TRANSFERENCIA'"
                  >
                    <b>Conta origem</b>
                    <small>{{ item.origin_account_name }}</small>
                  </div>
                  <div
                    class="col-md-4 pt-0 pb-0 d-flex flex-column text-twelve"
                    v-if="item.type == 'TRANSFERENCIA'"
                  >
                    <b>Valor</b>
                    <small>- {{ formatMoney(String(item.value)) }}</small>
                  </div>
                  <div
                    class="col-md-8 pt-0 pb-0 d-flex flex-column text-twelve"
                    v-if="item.type == 'TRANSFERENCIA'"
                  >
                    <b>Conta destino</b>
                    <small>{{ item.destination_account_name }}</small>
                  </div>
                  <div
                    class="col-md-4 pt-0 pb-0 d-flex flex-column text-twelve"
                    v-if="item.type == 'TRANSFERENCIA'"
                  >
                    <b>Valor</b>
                    <small>{{ formatMoney(String(item.value)) }}</small>
                  </div>
                  <div
                    class="col-md-12 pt-0 pb-0 d-flex flex-column text-twelve"
                    v-if="item.type == 'TRANSFERENCIA'"
                  >
                    <b>Data</b>
                    <small>
                      {{ moment(item.created_at).format("DD/MM/YYYY") }}
                    </small>
                  </div>
                  <div class="col-md-12 p-0"></div>
                  <div class="col-md-4 pt-0 pb-0 text-twelve">
                    <b>Descrição</b>
                  </div>
                  <div
                    class="col-md-2 pt-0 pb-0 text-twelve"
                    v-if="item.type != 'TRANSFERENCIA'"
                  >
                    <b>Valor</b>
                  </div>
                  <div
                    class="col-md-2 pt-0 pb-0 text-twelve"
                    v-if="item.type != 'TRANSFERENCIA'"
                  >
                    <b>Categoria</b>
                  </div>
                  <div
                    class="col-md-4 pt-0 pb-0 text-twelve"
                    v-if="item.type != 'TRANSFERENCIA'"
                  >
                    <b>Centro de custo/lucro</b>
                  </div>

                  <div class="co-md-12 p-0"></div>

                  <div
                    class="col-md-12 pt-0 pb-0 text-twelve"
                    v-if="item.type == 'TRANSFERENCIA'"
                  >
                    <small>{{ item.description }}</small>
                  </div>
                </div>
                <div
                  class="row m-0"
                  v-show="item.type != 'TRANSFERENCIA'"
                  v-for="(
                    finance_launch_bills_to_pay_installments_item, key
                  ) in item.finance_launch_bills_to_pay_installments_items"
                  :key="key"
                >
                  <div class="col-md-4 pt-0 pb-0 text-twelve">
                    <small>{{
                      finance_launch_bills_to_pay_installments_item.description
                    }}</small>
                  </div>
                  <div class="col-md-2 pt-0 pb-0 text-twelve">
                    <small>{{
                      formatMoney(
                        String(
                          finance_launch_bills_to_pay_installments_item.value
                        )
                      )
                    }}</small>
                  </div>
                  <div class="col-md-2 pt-0 pb-0 text-twelve">
                    <small>{{
                      finance_launch_bills_to_pay_installments_item.finance_configuration_category_name
                    }}</small>
                  </div>
                  <div class="col-md-4 pt-0 pb-0 text-twelve">
                    <small>{{
                      finance_launch_bills_to_pay_installments_item.finance_configuration_profit_cost_center_description
                    }}</small>
                  </div>
                </div>
                <div class="row m-0">
                  <div
                    class="col-md-12 pt-0 pb-0 d-flex align-items-center justify-content-end text-twelve"
                  >
                    <small class="mr-2">Criado em:</small>
                    <small class="mr-2">
                      {{
                        moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
                      }}
                    </small>
                    <small class="mr-2">por:</small>
                    <small>
                      {{ item.user_name }}
                    </small>
                  </div>
                  <div
                    class="col-md-12 pt-0 pb-0 d-flex align-items-center justify-content-end text-twelve"
                  >
                    <small class="mr-2">Atualizado em:</small>
                    <small>
                      {{
                        moment(item.updated_at).format("DD/MM/YYYY HH:mm:ss")
                      }}
                    </small>
                  </div>
                </div>
              </span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.profit_cost_center`]="{ item }">
            <v-tooltip bottom max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <p class="m-0 limit-text worksansr">
                    {{
                      item.finance_configuration_profit_cost_center_description
                    }}
                  </p>
                </div>
              </template>
              <span>
                {{ item.finance_configuration_profit_cost_center_description }}
              </span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.value`]="{ item }">
            <div
              style="min-width: 100px !important"
              v-if="
                item.type != 'previous_balance' &&
                item.type != 'opening_balance'
              "
              :class="[`c-${item.color}`, 'text-right']"
            >
              {{ item.color == "danger" ? "-" : "" }}
              {{ formatMoney(String(item.value).replace("-", "")) }}
            </div>
            <div
              v-if="
                item.type == 'previous_balance' ||
                item.type == 'opening_balance'
              "
              :class="[item.value > 0 ? 'c-success' : 'c-danger', 'text-right']"
            >
              {{ formatMoney(String(item.value)) }}
            </div>
          </template>
          <template v-slot:[`item.is_repeat`]="{ item }">
            <div v-if="item.is_repeat == 'MAIS_DE_UMA_VEZ'" class="d-flex">
              <small class="v-dark noBorderRadius text-nine">
                {{ item.index_key }}/{{ item.how_many_times }}
              </small>
              <small class="v-clean noBorderRadius text-nine">
                {{ item.periodicity }}
              </small>
            </div>
            <div v-if="item.is_repeat == 'SEMPRE'">
              <v-tooltip bottom max-width="300">
                <p class="m-0 worksansr">
                  <small class="v-dark noBorderRadius text-nine"
                    ><i class="fas fa-sync-alt"></i
                  ></small>
                  <small class="v-clean noBorderRadius text-nine">
                    {{ item.periodicity }}
                  </small>
                </p>
                <span> Número da repetição: {{ item.index_key }} </span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </div>
      <div v-if="total == 0" class="p-2 text-center warning-alert">
        Não existem lançamentos para esta filtragem.
      </div>
      <hr />
      <div class="row mb-5">
        <div class="col-md-12 pt-0 pb-0">
          <div class="row d-flex align-items-center">
            <div class="col-md-4">
              <p class="m-0 worksansr">Total de ganhos</p>
            </div>
            <div class="col-md-6">
              <b-progress
                variant="success"
                :value="total_gain"
                :max="max_progress"
              />
            </div>
            <div class="col-md-2 text-right">
              <p
                :class="[
                  'm-0',
                  parseFloat(total_gain) >= 0 ? 'c-success' : 'c-danger',
                ]"
              >
                {{
                  parseFloat(total_gain) >= 0
                    ? formatMoney(String(total_gain))
                    : `${formatMoney(String(total_gain))}`
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <div class="row d-flex align-items-center">
            <div class="col-md-4">
              <p class="m-0 worksansr">Total de gastos</p>
            </div>
            <div class="col-md-6">
              <b-progress
                variant="danger"
                :value="total_spent"
                :max="max_progress"
              />
            </div>
            <div class="col-md-2 text-right">
              <p class="m-0 c-danger">
                {{ formatMoney(String(total_spent)) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </b-overlay>
  </div>
</template>

<script>
import { formatMoney } from "../../../../../lib/format";

import moment from "moment";

export default {
  name: "CompareBillingTable",

  components: {},

  props: {
    data: Array,
    total: [Number, String],
    total_gain: [Number, String],
    total_spent: [Number, String],
    max_progress: [Number, String],
    period_result: [Number, String],
    forecast_balance: [Number, String],
    month: [String],
  },

  data() {
    return {
      loading: false,

      dayMonthYear: "month",
      filter_by_period: false,

      options: {
        page: 1,
      },

      headers: [
        { text: "DATA", value: "date", sortable: false },
        { text: "CATEGORIA", value: "categories", sortable: false },
        { text: "Descrição", value: "description", sortable: false },
        { text: "VALOR", value: "value", sortable: false, align: "end" },
        { text: "", value: "is_repeat", sortable: false },
      ],

      errors: [],
    };
  },

  created() {},

  methods: {
    formatMoney,
    moment,
  },
};
</script>